import ListProcesses from "@/views/organization/reporting/process/ListProcesses.vue";
import ShowReports from "@/views/organization/reporting/process/ShowReports.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "reporting",
  permission: "process"
});

export default [
  {
    path: "/org/:organization_id/reporting/process/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/org/:organization_id/reporting/process/list_processes",
    name: routeName('list_processes'),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/reporting/process/:harvest_process_id/show_reports",
    name: routeName('show_reports'),
    component: ShowReports,
    props: true,
    meta: META
  }
];
